import React, { useState, useEffect, useRef } from "react";
import { get } from '@aws-amplify/api';
import * as Auth from 'aws-amplify/auth';
import awsconfig from './aws-exports';
import { downloadFile, uploadFile } from "./lib/common";
import './App.css';
import axios from 'axios';
import AppLayout from './components/AppLayout';

const IcPerformance = ({ signOut }) => {
  const [securities, setSecurities] = useState("");
  const [aiPrompt, setAiPrompt] = useState("");
  let [data, setData] = useState({"ytdProfit": "", "oneYProfit": "", "lifeProfit": "", "annualizedProfit": ""});
  let [message, setMessage] = useState("Calculating Performance ...");
  const [error, setError] = useState('');
  const [hide, setHide] = useState("hidden");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  //let aiResponse = useRef("");
  const [aiResponse, setAiResponse] = useState("");
  let mydata = useRef();
  let email = useRef();

  useEffect(() => {
    console.log("Executing useEffect");
    new Promise(async (resolve, reject)=>{
      await Auth.fetchAuthSession();
      // Retrieve the user's email address
      const user = await Auth.fetchUserAttributes();
      console.log("useEffect : email = " + JSON.stringify(user.email));
      email.current = await user.email
      await Promise.resolve(email.current)
      .then(() => {
        console.log("useEffect : getIcPerformance");
        new Promise(async (resolve, reject)=>{
          await getIcPerformance(securities, aiPrompt)
        })
      })
      await setTimeout(() => resolve("done"), 3000);
    })
    
  }, []);

  async function getIcPerformance(securities, aiPrompt) {
    console.log("Executing getIcPerformance");
    const myAPI="mktappapi";
    let path = '/icperformance'; 
    
    let passApiStr = await path + "/" + email.current;
    passApiStr = passApiStr.replace(/"/g, '');
    
    await console.log("getIcPerformance : passApiStr = "+ passApiStr);

    try {
      //await Promise.resolve(await get(myAPI, passApiStr))
      const response = await get({
        apiName: myAPI,
        path: passApiStr,
      }).response;
      let resp = await response.body.json();
      await Promise.resolve(resp)
        .then(async () =>{
          await console.log("getIcPerformance : resp = ", resp);
          await setData(await resp);
          await console.log("getIcPerformance : data = " + JSON.stringify(data));
          setMessage("");
          setError("");
      })
      .catch(error => {
        setError(error.message);
        console.log("getIcPerformance : Error = " + error.message);
      }) 
    } catch (error) {}
  }

  const jsonToUrlString = (json) => {
    const params = encodeURIComponent(JSON.stringify(json));
    return params.toString();
  };


  const formatCurrency = (value) => {
    if (!value) return '$0.00';
    const num = parseFloat(value);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  const MetricCard = ({ label, value, icon }) => (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      border: '1px solid rgba(229, 231, 235, 1)',
      padding: '24px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.2s'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
    }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '8px',
          background: 'rgba(59, 130, 246, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '12px'
        }}>
          <span style={{ fontSize: '20px' }}>{icon}</span>
        </div>
        <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: 'rgba(107, 114, 128, 1)',
          margin: 0,
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}>
          {label}
        </h3>
      </div>
      <div style={{
        fontSize: '28px',
        fontWeight: '700',
        color: parseFloat(value) >= 0 ? '#10b981' : '#ef4444'
      }}>
        {formatCurrency(value)}
      </div>
    </div>
  );

  return (
    <AppLayout signOut={signOut}>
      <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
            Iron Condor Performance
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(107, 114, 128, 1)' }}>
            Track your Iron Condor trading performance metrics
          </p>
        </div>

        {/* Loading Message */}
        {message && (
          <div style={{
            padding: '12px',
            marginBottom: '24px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px',
            color: '#3b82f6',
            fontWeight: '500',
            textAlign: 'center'
          }}>
            {message}
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div style={{
            padding: '12px',
            marginBottom: '24px',
            background: 'rgba(239, 68, 68, 0.1)',
            color: '#ef4444',
            borderRadius: '8px',
            fontWeight: '500',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {/* Metrics Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px',
          marginBottom: '24px'
        }}>
          <MetricCard
            label="YTD Profit"
            value={data.ytdProfit}
            icon="📅"
          />
          <MetricCard
            label="Annualized Profit"
            value={data.annualizedProfit}
            icon="📈"
          />
          <MetricCard
            label="1 Year Profit"
            value={data.oneYProfit}
            icon="🗓️"
          />
          <MetricCard
            label="Lifetime Profit"
            value={data.lifeProfit}
            icon="💰"
          />
        </div>

        {/* Info Card */}
        <div style={{
          background: 'rgba(59, 130, 246, 0.05)',
          borderRadius: '8px',
          border: '1px solid rgba(59, 130, 246, 0.2)',
          padding: '16px'
        }}>
          <p style={{
            fontSize: '14px',
            color: 'rgba(55, 65, 81, 1)',
            margin: 0,
            lineHeight: '1.6'
          }}>
            <strong>Note:</strong> Performance metrics are calculated based on your closed Iron Condor positions.
            YTD (Year-to-Date) shows performance from January 1st of the current year. Annualized profit
            represents the projected annual return based on your current performance rate.
          </p>
        </div>
      </div>
    </AppLayout>
  );
};

export default IcPerformance;
